<template>
    <div component="OrderItem">
        <div class="number">{{ index + 1 }}</div>
        <div class="character-wrapper" :style="{ background: getColorById(character.farba) }">
            <div class="character">
                <div class="label">Character:</div>
                <div class="name">{{ character.meno }}</div>
                <div class="winner" v-if="winner">{{ winner.meno_priezvisko }}</div>

                <btn
                    :icon="'close'"
                    v-if="!getOrderProject.hasOrder"
                    :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                    color="transparent"
                    @click="removeConfirm = true"
                />
                <div
                    class="warning"
                    :class="{ show: removeConfirm }"
                    :style="{ background: `linear-gradient(90deg, transparent, ${charColor} 40%)!important` }"
                >
                    <div class="label">Remove character?</div>
                    <btn
                        :icon="'close'"
                        color="ghost"
                        for-background="dark"
                        :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                        @click.stop="removeConfirm = false"
                    />
                    <btn
                        :icon="'check'"
                        color="ghost"
                        for-background="dark"
                        :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                        @click.stop="removeFromCharacterList(character.id)"
                    />
                </div>
            </div>

            <div class="inputs" v-if="winner">
                <price-inputs v-if="!disabled" :winner="winner" :typ="typ" :color="getColorById(character.farba)" />
            </div>
        </div>

        <div class="price">{{ character.cena }}&nbsp;<small>EUR</small></div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PriceInputs from '@/components/Project/Order/PriceInputs.vue';

export default {
    name: 'OrderItem',

    components: {
        PriceInputs,
    },

    props: {
        index: {
            type: Number,
            required: true,
        },
        typ: {
            type: Number,
            required: true,
        },
        character: {
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
    },

    async mounted() {
        this.loading = false;
    },

    data() {
        return {
            fatalError: false,
            loading: true,
            immediate: true,
            removeConfirm: false,
        };
    },

    methods: {
        removeFromCharacterList(character_id) {
            this.$emit('removeFromCharacterList', character_id);
            this.removeConfirm = false;
        },
    },

    computed: {
        ...mapGetters(['getOrderProject', 'getColorById', 'getIsSmallerScreen']),

        charColor() {
            return this.getColorById(this.character.farba);
        },

        winner() {
            return (
                this.character?.character?.candidates?.reduce((curr, item) =>
                    item.pivot.poradie < curr.pivot.poradie ? item : curr
                ) || false
            );
        },
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='OrderItem'] {
    display: flex;
    width: 100%;
    min-height: 40px;
    border-bottom: 1px solid @border;
    color: @black;
    //background-color: fade(@black, 3%);

    .number {
        .flex-center;
        width: 40px;
        padding: 5px 15px;
    }

    .character-wrapper {
        flex-direction: column;
        display: flex;
        flex: 1;

        .inputs {
            background: rgba(255, 255, 255, 0.6);
        }
    }

    .character {
        overflow: hidden;
        position: relative;
        .flex-row;
        justify-content: flex-start;
        padding: 5px 8px 5px 15px;
        width: 100%;
        min-width: 320px;

        .label {
            font-size: 12px;
        }

        .name {
            margin-left: 5px;
            font-size: 15px;
            font-weight: 700;
        }

        .winner {
            margin-left: 10px;
            font-size: 12px;
        }

        button {
            margin-left: auto;
        }
    }

    .price {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-left: auto;
        padding: 5px 15px;
        font-weight: bold;
        width: 100px;
    }

    .warning {
        .flex-row;
        justify-content: flex-end;
        position: absolute;
        right: 0;
        height: 100%;
        width: 100%;
        z-index: 6;
        transition: 0.3s;
        transform: translateX(110%);
        padding: 10px 10px 10px 30px;

        &.show {
            transform: translateX(0);
        }

        .label {
            font-weight: 700;
            color: white;
            margin-right: 10px;
            white-space: nowrap;
        }

        button {
            margin-left: 3px;
        }
    }

    &.confirm {
        .name {
            opacity: 0.3;
        }
    }
}
</style>
